import { render, staticRenderFns } from "./AdminMortgageSettings.vue?vue&type=template&id=60f16617&"
import script from "./AdminMortgageSettings.vue?vue&type=script&lang=js&"
export * from "./AdminMortgageSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminMortgageSettings.vue?vue&type=style&index=0&id=60f16617&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports